import { Check } from '@timelyapp/icons/solid-icons';
import React from 'react';
import { Box } from '../../box/Box';
import { Text } from '../../text/Text';
import type { DropdownMenuItem } from './DropdownMenu.types';
import { DropdownMenu as DropdownMenuPrimitive } from './DropdownMenuPrimitives';

const HorizontalItemBody = ({ item }: { item: DropdownMenuItem }) => {
  const isCheckbox = item.type === 'checkboxItem';
  const radioOrCheckbox = ['radioItem', 'checkboxItem'].includes(item.type);
  const rightIcon = 'icon' in item && !!item.icon && radioOrCheckbox;
  const leftIcon = 'icon' in item && !!item.icon && !radioOrCheckbox;
  return (
    <>
      {radioOrCheckbox && (
        <DropdownMenuPrimitive.ItemIndicator>
          <Check />
        </DropdownMenuPrimitive.ItemIndicator>
      )}
      {leftIcon && (
        <DropdownMenuPrimitive.Icon
          icon={item.icon}
          style={isCheckbox ? { position: 'static' } : {}}
        />
      )}
      {'label' in item && item.label}
      {'shortcutCombo' in item && (
        <DropdownMenuPrimitive.ShortcutCombo combo={item.shortcutCombo} />
      )}
      {/* Limited space, so gotta choose */}
      {'sidenote' in item && !!item.sidenote ? (
        <DropdownMenuPrimitive.RightSlot>{item.sidenote}</DropdownMenuPrimitive.RightSlot>
      ) : rightIcon ? (
        <DropdownMenuPrimitive.RightSlot>{item.icon}</DropdownMenuPrimitive.RightSlot>
      ) : item.type === 'subMenu' ? (
        <DropdownMenuPrimitive.RightSlot />
      ) : null}
    </>
  );
};
HorizontalItemBody.displayName = 'HorizontalItemBody';

export const GenericItemBody = ({ item }: { item: DropdownMenuItem }) => {
  const hasDescription = 'description' in item && !!item.description;

  if (!hasDescription) return <HorizontalItemBody item={item} />;

  return (
    <Box.Column gap="medium" width="100%">
      <Box.Row width="100%">
        <HorizontalItemBody item={item} />
      </Box.Row>
      <Text.Label ellipsis={2} size="xsmall" color="lowContrast">
        {item.description}
      </Text.Label>
    </Box.Column>
  );
};
GenericItemBody.displayName = 'GenericItemBody';
